import { RecordStatus } from '@app/enumerations';

export default class BuildingStatusInfo {
	public statusCode: RecordStatus | null = null;
	public statusMessage: string | null = null;

	public constructor() {

	}
}